import Vue from 'vue'
import VueRouter from 'vue-router'

import Candidate from '../Candidate.vue'

Vue.use(VueRouter)

const routes = [
  {
    name: 'candidate',
    path: '/ehdokas/',
    component: Candidate,
  },
]

const router = new VueRouter({
  // base: '/embed/',
  mode: 'history',
  routes,
})

export default router
